import axios from 'lib/axios'

export const renewInventory = async (subscriptionCompanyId: number) => {
  try {
    const response = await axios.patch(
      `/subscription_company/${subscriptionCompanyId}/renew`,
      {},
      {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }
    )

    return response.data
  } catch (error: any) {
    console.error('Error al renovar el inventario:', error)

    if (error.response?.data) {
      console.error('Detalle del error:', error.response.data)
    }

    throw error
  }
}
